import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const documentTypeFilterLabel = () => t({ message: 'Document type', comment: 'Insights filter: Document type' });
export function DocumentTypeFilter() {
    return (<CommonMetadataAllowedValuesFilter name="DocumentType" field="metadataDocumentDocumentType" label={documentTypeFilterLabel()}/>);
}
